import React, { useEffect, useState } from 'react';
import { httpGetSpotsByLocation } from "../hooks/spot/api";
import MySpotList from '../components/spot/MySpotList';
//import withSplashScreen from '../components/splash/SplashScreen';
import Skeleton from '@mui/material/Skeleton';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

const MySpotListPage = () => {

  const [spots, setSpots] = useState([]);
  useEffect(() => {
    httpGetSpotsByLocation().then(
      async (result) => { 
        setSpots(result)
      }
    ).catch((err) => 
      console.log(err)
    )
  }, [])
  
   const landingPage = () => {
        return <MySpotList spots={spots} />
  }

  return (
    spots.length>0 ? (
    <div>
      { landingPage() } 
    </div>
    ) : (
      <Box sx={{ width: '100%', alignContent: 'center', padding: '50px' }}>
          <Stack spacing={3}>
          <Skeleton variant="rectangular" width="100%"  height={50}/> 
          <Skeleton variant="rectangular" width="100%"  height={50}/> 
          <Skeleton variant="rectangular" width="100%"  height={50}/> 
          <Skeleton variant="rectangular" width="100%"  height={50}/> 
          <Skeleton variant="rectangular" width="100%"  height={50}/> 
          <Skeleton variant="rectangular" width="100%"  height={50}/> 
          <Skeleton variant="rectangular" width="100%"  height={50}/> 
          <Skeleton variant="rectangular" width="100%"  height={50}/> 
          </Stack>
        </Box>
    )
  )
}

//export default withSplashScreen(MySpotListPage);
export default MySpotListPage;